// Replace editorial text arrows without changing link labels or destinations.
export default function actionArrows() {
    document.querySelectorAll('a, button').forEach(link => {
        const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) {
            if (walker.currentNode.textContent.includes('→')) nodes.push(walker.currentNode);
        }
        nodes.forEach(node => {
            const fragment = document.createDocumentFragment();
            node.textContent.split('→').forEach((text, index) => {
                if (index) {
                    const icon = document.createElement('span');
                    icon.className = 'fa-solid fa-arrow-right lds-action-arrow';
                    icon.setAttribute('aria-hidden', 'true');
                    fragment.appendChild(icon);
                }
                fragment.appendChild(document.createTextNode(text));
            });
            node.replaceWith(fragment);
        });
    });
}
